/** @format */

import {
  FLEET_COMPANIES,
  PARTNERSHIP_ADVANTAGES,
  PARTNERSHIP_OTHER_SIDE_ADVANTAGES,
} from "@roadflex/constants";
import { HeadSeo } from "@roadflex/react-components-www";
import RoadFlexCustomers from "../../components/common-components/customer-success/customer-success";
import Panel1 from "../../components/partnership/panel1/panel1";
import Panel2 from "../../components/partnership/panel2/panel2";
import Panel3 from "../../components/partnership/panel3/panel3";
import Panel4 from "../../components/partnership/panel4/panel4";

export function PartnershipPage() {
  const keywordList: string[] = ["RoadFlex"];
  return (
    <>
      <HeadSeo
        url="${NEXT_PUBLIC_WWW_URL}/partnership"
        title="RoadFlex - Partner with RoadFlex"
        description="Give your customers financial products you'll both love. Find out how you can can build a synergistic relationship with RoadFlex."
        keywords={keywordList}
      />
      <Panel1 />
      <Panel2></Panel2>
      <Panel3
        advantages={PARTNERSHIP_ADVANTAGES}
        advantagesMutual={PARTNERSHIP_OTHER_SIDE_ADVANTAGES}
      ></Panel3>
      <Panel4></Panel4>
      <RoadFlexCustomers fleetCompanies={FLEET_COMPANIES} />
    </>
  );
}

export default PartnershipPage;
